/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFreeHandAdd = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m16.429 2.586 3.985 3.985L8.246 18.74c.218.15.41.304.582.442l.047.037c.638.51 1.013.781 1.625.781.612 0 .988-.27 1.625-.78l.047-.038C12.782 18.693 13.647 18 15 18s2.218.693 2.828 1.182l.047.037c.638.51 1.013.781 1.625.781H22v2h-2.5c-1.353 0-2.218-.693-2.828-1.182a9.474 9.474 0 0 0-.047-.037C15.988 20.27 15.612 20 15 20s-.987.27-1.625.78l-.047.038C12.718 21.307 11.853 22 10.5 22c-1.353 0-2.218-.693-2.828-1.182a11.845 11.845 0 0 0-.047-.037C6.987 20.27 6.612 20 6 20H3v-3.986zM6.157 18l8.429-8.429-1.157-1.157L5 16.843V18zm8.686-11L16 8.157l1.586-1.586-1.157-1.157zM4 4V1h2v3h3v2H6v3H4V6H1V4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFreeHandAdd as FreeHandAdd };
